import React, {useEffect, useState} from "react";
import Button from "../../../components/button";
import Breadcrumbs from "../../../components/breadcrumbs";
import Input from "../../../components/input";
import {ToastContainer, toast} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {useDispatch, useSelector} from "react-redux";
import {Link, useHistory} from "react-router-dom";
import {
    createCity,
    CREATE_CITY,
    clear_cities,
    getAllCities
} from "../../../redux/cities";
import SelectInput from "../../../components/select";
import Footer from "../../../components/footer";

const CreateCity = () => {
    const dispatch = useDispatch();
    let history = useHistory();

    const _get_all_provinces = useSelector(
        (state) => state.provinces_module._get_all_provinces
    );

    const [provinces, setProvinces] = useState([]);

    useEffect(() => {
        if (_get_all_provinces.data.datos) {
            setProvinces(_get_all_provinces.data.datos);
        }
    }, [_get_all_provinces]);

    const _create_city = useSelector(
        (state) => state.cities_module._create_city
    );
    const {token} = useSelector((state) => state.users_module.login.data) || null;

    const [form, setForm] = useState({
        nombre: "",
        id_provincia: 0,
    });

    useEffect(() => {
        if (_create_city.status === 201) {
            dispatch(clear_cities(CREATE_CITY));
            history.push("/ciudades");
            dispatch(getAllCities(token));
        } else if (_create_city.status !== 0) {
            dispatch(clear_cities(CREATE_CITY));
            toast.error(_create_city.message, {position: toast.POSITION.TOP_RIGHT});
        }
    }, [_create_city, dispatch, history, token]);


    const handleChange = (e) => {
        if (e.target.name === "id_provincia") {
            setForm({
                ...form,
                [e.target.name]: parseInt(e.target.value),
            });
        } else {
            setForm({
                ...form,
                [e.target.name]: e.target.value,
            });
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        //validate fields
        if (form.nombre === "") {
            toast.error("Debe ingresar el nombre", {position: toast.POSITION.TOP_RIGHT});
            return;
        }

        if (form.id_provincia === 0) {
            toast.error("Debe seleccionar una provincia", {position: toast.POSITION.TOP_RIGHT});
            return;
        }

        dispatch(createCity(token, form));
    };

    return (
        <div className="app-content content">
            <div className="content-overlay"/>

            <div className="content-wrapper">
                <div className="content-header row">
                    <div className="content-header-left col-12 mb-2 mt-3">
                        <Breadcrumbs
                            title="Ciudad"
                            items={[
                                {label: "Lista de ciudades", link: "/ciudades"},
                            ]}
                        />
                    </div>
                </div>
                <div className="content-body">
                    <div className="row">
                        <div className="col-12">
                            <form className="card" onSubmit={handleSubmit}>
                                <div className="card-header">
                                    <h4 className="card-title">Crear Ciudad</h4>
                                </div>
                                <div className="card-body">
                                    <div><ToastContainer/></div>
                                    <div className="row">
                                        <div className=" col-md-6">
                                            <Input
                                                name="nombre"
                                                label="Nombre"
                                                value={form.nombre}
                                                onChange={handleChange}
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="form-group">
                                                <label>Provincia</label>
                                                <SelectInput
                                                    label="provincia"
                                                    name="id_provincia"
                                                    value={form.id_provincia}
                                                    onChange={handleChange}
                                                    options={provinces ? provinces.map((item) => ({
                                                        name: item.nombre,
                                                        id: item.id,
                                                    })) : []}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer d-flex justify-content-end">
                                    <Link to="/ciudades" className="btn btn-outline-dark m-1">
                                        Cancelar
                                    </Link>
                                    <Button type="submit" text="Crear" theme="calendar" classes="m-1"/>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
};

export default CreateCity;
